import React from 'react';
import ComingSoon from './components/ComingSoon';

function App() {
  return <ComingSoon />;
}

export default App;